<!-- eslint-disable -->
<script setup>
import journaliesPayements from "@/components/ToPDF/reportFamille/journaliesPayements.vue";

import CardSearch from "@/components/CardSearch.vue";
 import { ref } from 'vue'; 
const expandedReglementstRows = ref([]);
</script>
<!-- eslint-disable -->
<template>
  <!-- <ButtonDates /> -->
  <CardSearch v-if="currentSite" @search="callFunctions" :operation="false" :etat="false" :caisse="true"
    :vendeur="true" />


  <div class="row">
    <div class="col-md-12">


      <div v-if="dataReportReglements.length > 0" class="row">

<div class="col-md-12 grid-margin stretch-card">
  <div class="card position-relative">
    <SectionLoaderView v-if="loadingRequest?.getReglements" />
    <div class="card-header">
      <h3 class="card-title text-left"> journalier paiements (1)
      </h3>
    </div>
    <div v-if="dataReportReglements.length > 0" class="card-body">
      <div class="table-responsive tableClasss"> 
        <DataTable showGridlines v-model:expandedRows="expandedReglementstRows"
          :value="dataReportReglements[0]">
          <Column expander style="width: 5rem" />
          <Column field="Libelle" header="Libelle" footer="Total" sortable></Column>
         
          <Column field="TotalValeur" header="Montant (€)" :footer="`${twoValueAfterComma(dataReportReglements[1].TotalValeur)} €`"
            sortable>
            <template #body="slotProps">
              {{ twoValueAfterComma(slotProps?.data?.TotalValeur) }} €

            </template>
          </Column>



          <template #expansion="slotProps">
            <div class="p-3">
              <DataTable :value="slotProps.data.LibFamille">
                <Column field="Libelle" header="Famille" sortable>
                  <template #body="slotProps">
                    {{ slotProps.data.Libelle }}
                  </template>
                </Column> 
                <Column field="TotalValeur" header="Montant (€)" sortable>
                  <template #body="slotProps">
                    {{ twoValueAfterComma(slotProps?.data?.TotalValeur)  }} €
                  </template>
                </Column>



              </DataTable>
            </div>
          </template>
        </DataTable>
 
      </div>
    </div>
    <div v-else class="card-body d-flex align-items-center justify-content-center">
      <datanotfound :text="$t(`content.message.datanotfound`)" />
    </div>
  </div>
</div>
 
</div>




      <div v-if="journalier_payments" class="row">
        <div class=" col-md-12 grid-margin stretch-card">
          <div class="card position-relative">
            <SectionLoaderView v-if="loadingRequest?.JournalierPayments" />
            <div class="card-header">
              <h3 class="card-title text-left">
                journalier paiements (2)
                <div class="float-end d-flex">
                  <journaliesPayements :exportTo="journalier_payments" :dateFrom="datePicker.date.from"
                    :dateTo="datePicker.date.to" />
                </div>
              </h3>
            </div>
            <div class="card-body">
              <DataTable v-if="journalier_payments['finaleResults']?.length > 0" showGridlines
                :value="journalier_payments['finaleResults']">
                <Column v-for="(value, key) in journalier_payments['finaleResults'][0]" :key="key" :field="key"
                  :header="key"
                  :footer="(key != 'LibSite' && key != 'Jour') ? twoValueAfterComma(journalier_payments.totalObject[key]) + ' €' : journalier_payments.totalObject[key]"
                  sortable>
                  <template #body="slotProps" :key=key>
                    <span v-if="key != 'LibSite' && key != 'Jour'">
                      {{ twoValueAfterComma(slotProps.data[key]) }} € <!-- Call twoValueAfterComma method -->
                    </span>
                    <span v-else>
                      {{ (slotProps.data[key]) }}
                    </span>
                  </template>
                </Column>

              </DataTable>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<!-- eslint-disable -->
<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import DoughnutChart from "@/components/chartVue/ChartDoughnut.vue";
import { Division, twoValueAfterComma } from "@/Utils/globale.js";
import { isMoreThan24HoursFake } from '@/Utils/useDateDiff'

export default {
  components: { DoughnutChart },
  watch: {
    'datePicker.date.range'(newDate, oldDate) {
      this.callFunctions();
    }
  },
  data() {
    return {
      journalier_payments: [],



      reports: {
        famille: [],
        tva: [],
        remise: [],
        statistiques: [],
        statistiques_caisse: [],
        reglements_by_libefamille: []
      },
      pagination: {
        page: 0,
        limit: 4,
        skip: 0,
        per_page: 50,
        data: [],
      },
      chartjs: {
        chartDataFamille: [],
        chartDataTVA: [],
        chartDataREMISE: [],
        chartDataReglements: [],
        chiffre_affaire_total: 0,
      },


    };
  },
  mounted() {



  },
  methods: {
    ...mapMutations(["setTicketID"]),
    ...mapActions(["JournalierPayments", "getReglements"]),
    Division,

    async getReportJournalierPayments(from, to) {
      this.journalier_payments = await this.JournalierPayments({
        url: "report/daily-payments",
        page: 1,
        limit: 0,
        range: this.datePicker.date.range,
        vendeur: "vendeur",
        site: this.currentSite?._id,
        WhereLibInArray: [
          { LibValeur: this.globalSearch?.SelectedLibVendeurs?.length ? this.globalSearch?.SelectedLibVendeurs : 'vendeur', LibKey: 'LibVendeur' },
          { LibValeur: this.globalSearch?.SelectedLibCaisses?.length ? this.globalSearch?.SelectedLibCaisses : 'caisse', LibKey: 'LibCaisse' },
          { LibValeur: null, LibKey: 'Operation' },
        ]
      });
      this.journalier_payments.site = this.currentSite
    },

   async callFunctions() {
      if (this.currentSite?._id) {
        const ok = await isMoreThan24HoursFake(this.datePicker.date.range)
        if (ok) {
          // ✅ Safe to continue search
          let range = this.datePicker.defaultDates.type ? this.datePicker.defaultDates.type : this.datePicker.date.from
          this.getReportJournalierPayments(range, this.datePicker.date.to);
          this.getReglementsGroups(range, this.datePicker.date.to);
        }        
      }
    },

    async getReglementsGroups(from, to) {
      let qte = "qte";
      let vendeur = "vendeur";
      this.reports.reglements_by_libefamille = await this.getReglements({
        url: "entetes/reglements-famille",
        range: this.datePicker.date.range,
        vendeur: "vendeur",
        site: this.currentSite?._id,
        qte: qte,
        WhereLibInArray: [
          { LibValeur: this.globalSearch?.SelectedLibVendeurs?.length ? this.globalSearch?.SelectedLibVendeurs : 'vendeur', LibKey: 'LibVendeur' },
          { LibValeur: this.globalSearch?.SelectedLibCaisses?.length ? this.globalSearch?.SelectedLibCaisses : 'caisse', LibKey: 'LibCaisse' },
          { LibValeur: null, LibKey: 'Operation' },
        ]
      });
        
 
    }, 
  },
  computed: {
    ...mapGetters({ isRole: "isRole", isAuthenticated: "isAuthenticated", res: "StateRes", currentSite: "currentSite" }),
    ...mapState(["ticket_id", "datePicker", "globalSearch", "loadingRequest"]),
    dataReportReglements() { 
      return this.reports.reglements_by_libefamille; //results;
    },

  },
};
</script>
<!-- eslint-disable -->
<style></style>
